import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=5d937469&scoped=true&"
import script from "./_name.vue?vue&type=script&lang=js&"
export * from "./_name.vue?vue&type=script&lang=js&"
import style0 from "./_name.vue?vue&type=style&index=0&id=5d937469&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d937469",
  null
  
)

export default component.exports